<template>
  <section class="header-validation">
    <div class="header-division">
      <h1>Pedido #{{ orderStatus.reference }}</h1>
      <span v-if="showPixStatus()" class="warning">Aguardando PIX</span>
      <span v-else class="information" :class="orderStatus.pixSettled ? 'success' : (orderStatus.currentStep === 'Esperando Aprovação') ? 'information' :
        (orderStatus.currentStep === 'Aprovado - Pagamentos Pendentes') ? 'success' :
        ((orderStatus.currentStep === 'Rejeitado' || orderStatus.currentStep === 'Cancelado') ?
        'danger' : 'warning')">{{ orderStatus.pixSettled ? 'Pix Confirmado' :
        orderStatus.currentStep === 'Esperando Aprovação' ? (orderStatus.engineStatus === 'APPROVED' ? 'Em análise - auto_approval':'Em análise')  :
        orderStatus.currentStep === 'Aprovado - Pagamentos Pendentes' ? 'Aprovado' :
        orderStatus.currentStep  }}</span>
    </div>
    <ul class="steps-alternative" v-if="seller === 'Cvc' || data.sellerSourceChannel === 'smartpos' || data.sellerJourney === 'unified'" id="steps">
      <li v-if="data.sellerSourceChannel === 'smartpos'" :class="data.sellerSourceChannel === 'smartpos' ? 'active' : ''" v-b-tooltip.hover title="Maquininha">
        <div class="label">Jornada de Onboarding</div>
        <div :class="data.sellerSourceChannel === 'smartpos' ? 'stap active maquininha' : 'stap'"><i class="icon-calculator"></i></div>
      </li>
      <li :class="data.checkout.startJourney === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Início da jornada">
        <div v-if="data.sellerSourceChannel !== 'smartpos'" class="label">Jornada de Onboarding</div>
        <div :class="data.checkout.startJourney === 'OK' ? 'stap active' : 'stap'"><i class="icon-handbag"></i></div>
      </li>
      <li :class="data.checkout.socialLogin === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Login social">
        <div :class="data.checkout.socialLogin === 'OK' ? 'stap active' : 'stap'"><i class="icon-like"></i></div>
      </li>
      <li :class="data.checkout.installment === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Parcelamento">
        <div :class="data.checkout.installment === 'OK' ? 'stap active' : 'stap'"><i class="icon-price-tag"></i></div>
      </li>
      <li v-if="data.sellerSourceChannel === 'smartpos'" :class="data.checkout.address === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Adicionar endereço">
        <div :class="data.checkout.address === 'OK' ? 'stap active' : 'stap'"><i class="icon-location-2"></i></div>
      </li>
      <li :class="data.checkout.selfie === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Selfie">
        <div :class="data.checkout.selfie === 'OK' ? 'stap active' : 'stap'"><i class="icon-user-circle"></i></div>
      </li>
      <li :class="data.onboarding.documents === 'OK'|| data.onboarding.documents === 'VALIDATED' ? 'active' : ''" v-b-tooltip.hover title="Envio de documento" v-if="data.onboarding.documents !== 'OK'">
        <div :class="data.onboarding.documents === 'OK' || data.onboarding.documents === 'VALIDATED' ? 'stap active' : 'stap'"><i class="icon-fingerprint"></i></div>
      </li>
      <li :class="data.onboarding.registration === 'OK' || data.onboarding.registration === 'VALIDATED' ? 'active' : ''" v-b-tooltip.hover title="Validação de dados" v-if="data.onboarding.registration !== 'OK'">
        <div :class="data.onboarding.registration === 'OK' || data.onboarding.registration === 'VALIDATED' ? 'stap active' : 'stap'"><i class="icon-hand-bill-2"></i></div>
      </li>
      <li :class="data.onboarding.address === 'OK' || data.onboarding.address === 'VALIDATED' ? 'active' : ''" v-b-tooltip.hover title="Validação de endereço" v-if="data.onboarding.address !== 'OK'">
        <div :class="data.onboarding.address === 'OK' || data.onboarding.address === 'VALIDATED' ? 'stap active' : 'stap'"><i class="icon-location-2"></i></div>
      </li>
      <li :class="data.onboarding.whatsapp === 'VALIDATED' ? 'active' : ''" v-b-tooltip.hover title="Validação do Whatsapp">
        <div :class="data.onboarding.whatsapp === 'VALIDATED' ? 'stap active' : 'stap'"><i class="icon-message-1-heart"></i></div>
      </li>
      <li :class="data.onboarding.whatsapp === 'VALIDATED' ? 'active' : ''" v-b-tooltip.hover title="Cadastro concluído">
        <div :class="handleRegistrationCompleted() === 'OK' ? 'stap completed' : 'stap'"><i class="icon-check-circle"></i></div>
      </li>
      <li v-if="data.sellerSourceChannel === 'smartpos'" v-b-tooltip.hover title="Token validado">
        <div :class="tokenData.validated ? 'stap completed' : 'stap'"><i class="icon-firewall-done"></i></div>
      </li>
    </ul>
    <ul class="steps-ame" v-else-if="data.sellerSourceChannel === 'AME DIGITAL'">
      <li :class="data.checkout.startJourney === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Início da jornada">
        <div class="label">Fluxo de Checkout</div>
        <div :class="data.checkout.startJourney === 'OK' ? 'stap active' : 'stap'"><i class="icon-handbag"></i></div>
      </li>
      <li :class="data.checkout.socialLogin === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Login social">
        <div :class="data.checkout.socialLogin === 'OK' ? 'stap active' : 'stap'"><i class="icon-like"></i></div>
      </li>
      <li :class="data.checkout.installment === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Parcelamento">
        <div :class="data.checkout.installment === 'OK' ? 'stap active' : 'stap'"><i class="icon-price-tag"></i></div>
      </li>
      <li :class="data.checkout.startJourney === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Split" v-if="data.checkout.split === 'OK'">
        <div class="stap split"><i class="icon-share-3"></i></div>
      </li>
      <li :class="data.checkout.selfie === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Selfie">
        <div :class="data.checkout.selfie === 'OK' ? 'stap active' : 'stap'"><i class="icon-user-circle"></i></div>
      </li>
      <li :class="data.checkout.smsValidation === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Validação por SMS">
        <div :class="data.checkout.smsValidation === 'OK' ? 'stap active' : 'stap'"><i class="icon-smartphone-hand-1"></i></div>
      </li>
      <li v-b-tooltip.hover title="Cadastro concluído">
        <div :class="handleRegistrationCompleted() === 'OK' ? 'stap completed' : 'stap'"><i class="icon-check-circle"></i></div>
      </li>
    </ul>
                          <!--Nova Jornada no else-->
     <ul class="steps-default" v-else-if="data.sellerSourceChannel === 'NEW_JOURNEY'">
      <li :class="data.newCheckout.dataStep === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Dados Iniciais">
        <div class="label">Fluxo de Checkout</div>
        <div :class="data.newCheckout.dataStep === 'OK' ? 'stap active' : 'stap'"><i class="icon-handbag"></i></div>
      </li>
      <li :class="data.newCheckout.installmentStep === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Parcelamento">
        <div :class="data.newCheckout.installmentStep === 'OK' ? 'stap active' : 'stap'"><i class="icon-price-tag"></i></div>
      </li>
      <li :class="data.newCheckout.phoneStep === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Validação por SMS/E-mail">
        <div :class="data.newCheckout.phoneStep === 'OK' ? 'stap active' : 'stap'"><i class="icon-smartphone-hand-1"></i></div>
      </li>
      <li :class="data.newCheckout.selfieStep === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Selfie">
        <div :class="data.newCheckout.selfieStep === 'OK' ? 'stap active' : 'stap'"><i class="icon-user-circle"></i></div>
      </li>
      <li :class="data.newCheckout.contractStep === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Assinatura do Contrato">
        <div :class="data.newCheckout.contractStep === 'OK' ? 'stap active' : 'stap'"><i class="fa fa-file"></i></div>
      </li>
      <li :class="data.newCheckout.waittingManualApprovalStep === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Pendente de aprovação manual">
        <div :class="data.newCheckout.waittingManualApprovalStep === 'OK' ? 'stap active' : 'stap'"><i class="fa fa-hourglass-end"></i></div>
      </li>
      <li :class="data.newCheckout.qrCodeStep === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Pagamento da Entrada">
        <div :class="data.newCheckout.qrCodeStep === 'OK' ? 'stap active' : 'stap'"><i class="fa fa-qrcode"></i></div>
      </li>
      <li :class="data.newCheckout.approvedStep === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Aprovado">
        <div :class="data.newCheckout.approvedStep === 'OK' ? 'stap active' : 'stap'"><i class="fa fa-check-circle-o"></i></div>
      </li>
    </ul>
    <ul class="steps-default" v-else>
      <li :class="data.checkout.startJourney === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Início da jornada">
        <div class="label">Fluxo de Checkout</div>
        <div :class="data.checkout.startJourney === 'OK' ? 'stap active' : 'stap'"><i class="icon-handbag"></i></div>
      </li>
      <li :class="data.checkout.socialLogin === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Login social">
        <div :class="data.checkout.socialLogin === 'OK' ? 'stap active' : 'stap'"><i class="icon-like"></i></div>
      </li>
      <li :class="data.checkout.installment === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Parcelamento">
        <div :class="data.checkout.installment === 'OK' ? 'stap active' : 'stap'"><i class="icon-price-tag"></i></div>
      </li>
      <li :class="data.checkout.smsValidation === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Validação por SMS">
        <div :class="data.checkout.smsValidation === 'OK' ? 'stap active' : 'stap'"><i class="icon-smartphone-hand-1"></i></div>
      </li>
      <li :class="data.checkout.startJourney === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Split" v-if="data.checkout.split === 'OK'">
        <div class="stap split"><i class="icon-share-3"></i></div>
      </li>
      <li :class="data.checkout.selfie === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Selfie">
        <div :class="data.checkout.selfie === 'OK' ? 'stap active' : 'stap'"><i class="icon-user-circle"></i></div>
      </li>
      <li :class="data.checkout.selfie === 'OK' ? 'active' : ''"></li>
      <li :class="data.onboarding.socialLogin === 'OK' ? 'active' : ''" v-b-tooltip.hover title="Login social">
        <div class="label">Fluxo de Validação</div>
        <div :class="data.onboarding.socialLogin === 'OK' ? 'stap active' : 'stap'"><i class="icon-like"></i></div>
      </li>
      <li :class="data.onboarding.documents === 'OK'|| data.onboarding.documents === 'VALIDATED' ? 'active' : ''" v-b-tooltip.hover title="Envio de documento" v-if="data.onboarding.documents !== 'OK'">
        <div :class="data.onboarding.documents === 'OK' || data.onboarding.documents === 'VALIDATED' ? 'stap active' : 'stap'"><i class="icon-fingerprint"></i></div>
      </li>
      <li :class="data.onboarding.registration === 'OK' || data.onboarding.registration === 'VALIDATED' ? 'active' : ''" v-b-tooltip.hover title="Validação de dados" v-if="data.onboarding.registration !== 'OK'">
        <div :class="data.onboarding.registration === 'OK' || data.onboarding.registration === 'VALIDATED' ? 'stap active' : 'stap'"><i class="icon-hand-bill-2"></i></div>
      </li>
      <li :class="data.onboarding.address === 'OK' || data.onboarding.address === 'VALIDATED' ? 'active' : ''" v-b-tooltip.hover title="Validação de endereço" v-if="data.onboarding.address !== 'OK'">
        <div :class="data.onboarding.address === 'OK' || data.onboarding.address === 'VALIDATED' ? 'stap active' : 'stap'"><i class="icon-location-2"></i></div>
      </li>
      <li :class="data.onboarding.whatsapp === 'VALIDATED' ? 'active' : ''" v-b-tooltip.hover title="Validação do Whatsapp">
        <div :class="data.onboarding.whatsapp === 'VALIDATED' ? 'stap active' : 'stap'"><i class="icon-message-1-heart"></i></div>
      </li>
      <li v-b-tooltip.hover title="Cadastro concluído">
        <div :class="handleRegistrationCompleted() === 'OK' ? 'stap completed' : 'stap'"><i class="icon-check-circle"></i></div>
      </li>
    </ul>
    <div class="header-division">
      <template v-if="orderStatus.currentStep !== 'Aprovado - Pagamentos Pendentes' && orderStatus.currentStep !== 'Rejeitado' && orderStatus.currentStep !== 'Cancelado' && orderStatus.currentStep !== 'Abandonado'">
        <button class="reject" @click="rejectOpen">Rejeitar</button>
        <button class="approve" @click="approveOpen">Aprovar</button>
      </template>
      <template v-else-if="orderStatus.currentStep === 'Aprovado - Pagamentos Pendentes' && showPixStatus()">
        <button class="cancel" @click="cancelTransaction('BoletoFlex FIDC')">Cancelar pedido</button>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      data: {},
      orderStatus: {},
      tokenData: {}
    }
  },
  mounted () {
    this.getCustomerSteps()
    this.getCustomerOrderStatus()
    this.checkTokenValidation()
  },
  methods: {
    setWidthToSteps () {
      if (
        this.data.onboarding.documents === 'OK' ||
        this.data.onboarding.registration === 'OK' ||
        this.data.onboarding.address === 'OK'
      ) {
        document.getElementById('steps').style.width = '320px'
      }

      if (
        this.data.onboarding.documents === 'OK' &&
        this.data.onboarding.registration === 'OK'
      ) {
        document.getElementById('steps').style.width = '280px'
      }

      if (
        this.data.onboarding.address === 'OK' &&
        this.data.onboarding.registration === 'OK'
      ) {
        document.getElementById('steps').style.width = '280px'
      }

      if (
        this.data.onboarding.documents === 'OK' &&
        this.data.onboarding.registration === 'OK' &&
        this.data.onboarding.address === 'OK'
      ) {
        document.getElementById('steps').style.width = '245px'
      }
      if (this.data.sellerSourceChannel === 'smartpos') {
        document.getElementById('steps').style.width = '440px'
      }
    },
    showPixStatus () {
      if (this.pixData.pix && this.pixData.status === 'Paga') {
        return false
      }

      if (this.pixData.pix && this.pixData.status === 'Cancelado') {
        return false
      }

      if (this.orderStatus.pixSettled) {
        return false
      }

      if (!this.pixData.pix) {
        return false
      }
      return true
    },
    handleRegistrationCompleted () {
      if (
        this.data.sellerSourceChannel === 'AME DIGITAL' &&
        this.data.checkout.startJourney === 'OK' &&
        this.data.checkout.socialLogin === 'OK' &&
        this.data.checkout.installment === 'OK' &&
        this.data.checkout.selfie === 'OK' &&
        this.data.checkout.smsValidation === 'OK'
      ) {
        return 'OK'
      }
      if (
        this.data.checkout.startJourney === 'OK' &&
        this.data.checkout.socialLogin === 'OK' &&
        this.data.checkout.installment === 'OK' &&
        this.data.checkout.smsValidation === 'OK' &&
        this.data.checkout.selfie === 'OK' &&
        this.data.onboarding.socialLogin === 'OK' &&
        (this.data.onboarding.documents === 'OK' ||
          this.data.onboarding.documents === 'VALIDATED') &&
        (this.data.onboarding.registration === 'OK' ||
          this.data.onboarding.registration === 'VALIDATED') &&
        (this.data.onboarding.address === 'OK' ||
          this.data.onboarding.address === 'VALIDATED') &&
        this.data.onboarding.whatsapp === 'VALIDATED'
      ) {
        return 'OK'
      }
      return 'PENDING'
    },
    getCustomerSteps () {
      this.$http
        .get(
          'api/order-validation/' + this.$route.params.txid + '/customer-steps'
        )
        .then(function (res) {
          this.data = res.data
          this.$emit('emit-customer-steps', this.data.checkout)
        })
        .then(() => {
          setTimeout(() => {
            this.setWidthToSteps()
          }, 750)
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getCustomerOrderStatus () {
      this.$http
        .get(
          'api/order-validation/' +
            this.$route.params.txid +
            '/customer-order-status'
        )
        .then(function (res) {
          this.orderStatus = res.data
          this.$emit('emit-order-status', this.orderStatus)
          this.$emit(
            'emit-order-transaction-status',
            this.orderStatus.currentStep
          )
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    approveOpen () {
      this.$emit('emitApproveOpen')
    },
    rejectOpen () {
      this.$emit('emitRejectOpen')
    },
    cancelTransaction (fdic) {
      this.$bvModal
        .msgBoxConfirm('Você confirma o CANCELAMENTO deste pedido?', {
          title: 'CANCELAMENTO',
          size: 'sm',
          okVariant: 'success',
          okTitle: 'SIM, cancelar pedido',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false
        })
        .then(value => {
          if (value === true) {
            this.loadingCancel = true
            this.$http
              .post('api/validations/' + this.$route.params.txid + '/cancel')
              .then(function (res) {
                this.loadingCancel = false
                this.$bvToast.toast(res.data, {
                  title: 'Cancelamento de pedido',
                  autoHideDelay: 5000,
                  variant: 'primary'
                })
                this.fetchData()
              })
              .catch(function (res) {
                console.log('Error')
                console.log(res)
                this.loadingCancel = false
                this.$bvToast.toast(res.data, {
                  title: 'Cancelamento de pedido',
                  autoHideDelay: 5000,
                  variant: 'danger'
                })
              })
          }
        })
        .catch(err => {
          console.log('Error: ' + err)
        })
    },
    async checkTokenValidation () {
      await this.$http
        .post('transactions/' + this.$route.params.txid + '/verifyToken')
        .then(function (res) {
          this.tokenData = res.data
        })
        .catch(function (res) {
          console.log('Error token validation')
          console.log(res)
        })
    }
  },
  watch: {
    rejectDone () {
      this.getCustomerOrderStatus()
      this.rejectDone = false
    },
    approveDone () {
      this.getCustomerOrderStatus()
      this.approveDone = false
    }
  },
  props: [
    'customerPhoneNumber',
    'rejectDone',
    'approveDone',
    'pixData',
    'seller'
  ]
}
</script>

<style lang="scss" scoped>
.header-validation {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;
  .header-division {
    display: flex;
  }
  h1 {
    font-size: 24px;
    padding: 0 16px;
    color: #666666;
    margin: 0;
  }
  span {
    display: flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 4px;
    &.information {
      background: rgba(66, 133, 244, 0.2);
      color: #4285f4;
      font-weight: 700;
      i {
        color: #4285f4;
      }
    }
    &.danger {
      background: rgba(186, 27, 34, 0.2);
      color: #ba1b22;
      i {
        color: #ba1b22;
      }
    }
    &.warning {
      background: rgba(240, 155, 27, 0.2);
      color: #f09b1b;
      i {
        color: #f09b1b;
      }
    }
    &.success {
      background: rgba(65, 189, 100, 0.2);
      color: #41bd64;
      i {
        color: #41bd64;
      }
    }
  }
  .steps-ame {
    display: table;
    table-layout: fixed;
    width: 255px;
    margin: 0;
    > li {
      text-align: center;
      display: table-cell;
      position: relative;
      i {
        font-size: 16px;
      }
      &:after {
        content: "";
        height: 2px;
        width: 100%;
        background-color: #ffffff;
        position: absolute;
        top: 15px;
        left: 50%;
        z-index: 0;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
      &.active {
        &:after {
          background-color: #4285f4 !important;
        }
      }
      &.completed {
        &:after {
          background-color: #41bd64 !important;
        }
      }
    }
    .stap {
      position: relative;
      width: 31px;
      height: 31px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      color: #e1e1e1;
      z-index: 10;
      &.active {
        background-color: #4285f4;
        color: #ffffff;
        &.maquininha {
          background-color: #f09b1b;
        }
      }
      &.split {
        background-color: #ffffff;
        color: #4285f4;
      }
      &.completed {
        background-color: #41bd64;
        color: #fff;
      }
      i {
        line-height: normal;
      }
    }
    .label {
      position: absolute;
      color: #666666;
      top: -20px;
      width: 125px;
    }
  }
  .steps-alternative {
    display: table;
    table-layout: fixed;
    width: 340px;
    margin: 0;
    > li {
      text-align: center;
      display: table-cell;
      position: relative;
      i {
        font-size: 16px;
      }
      &:after {
        content: "";
        height: 2px;
        width: 100%;
        background-color: #ffffff;
        position: absolute;
        top: 15px;
        left: 50%;
        z-index: 0;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
      &.active {
        &:after {
          background-color: #4285f4 !important;
        }
      }
      &.completed {
        &:after {
          background-color: #41bd64 !important;
        }
      }
    }
    .stap {
      position: relative;
      width: 31px;
      height: 31px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      color: #e1e1e1;
      z-index: 10;
      &.active {
        background-color: #4285f4;
        color: #ffffff;
        &.maquininha {
          background-color: #f09b1b;
        }
      }
      &.split {
        background-color: #ffffff;
        color: #4285f4;
      }
      &.completed {
        background-color: #41bd64;
        color: #fff;
      }
      i {
        line-height: normal;
      }
    }
    .label {
      position: absolute;
      color: #666666;
      top: -20px;
      width: 155px;
    }
  }
  .steps-default {
    display: table;
    table-layout: fixed;
    width: 450px;
    margin: 0;
    > li {
      text-align: center;
      display: table-cell;
      position: relative;
      i {
        font-size: 16px;
      }
      &:after {
        content: "";
        height: 2px;
        width: 100%;
        background-color: #ffffff;
        position: absolute;
        top: 15px;
        left: 50%;
        z-index: 0;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
      &.active {
        &:after {
          background-color: #4285f4 !important;
        }
      }
      &.completed {
        &:after {
          background-color: #41bd64 !important;
        }
      }
    }
    .stap {
      position: relative;
      width: 31px;
      height: 31px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      color: #e1e1e1;
      z-index: 10;
      &.active {
        background-color: #4285f4;
        color: #ffffff;
      }
      &.split {
        background-color: #ffffff;
        color: #4285f4;
      }
      &.completed {
        background-color: #41bd64;
        color: #fff;
      }
      i {
        line-height: normal;
      }
    }
    .label {
      position: absolute;
      color: #666666;
      top: -20px;
      width: 125px;
    }
  }
  a {
    padding: 0 16px;
  }
  button {
    width: 100px;
    height: 32px;
    border-radius: 5px;
    border: none;
    float: left;
    &.approve {
      background-color: #1c56e0;
      color: #ffffff;
    }
    &.reject {
      background-color: transparent;
      color: #c40e1e;
    }
    &.cancel {
      width: 134px;
      color: #fff;
      background-color: #ba1b22;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/HeaderCustomer.vue